import instance from "@/services/api";

export const bimSelectedParamsAPI = {
  async getList() {
    return await instance().get('/handbook/bim_selected_params/read/').then(res => res?.data)
  }
}

